<template>
	<div class="form-model-main">
		<div class="add-page-content">
			<div class="title">成员维护</div>
			<div class="content role-member-content">
				<a-tabs class="rm-tabs" defaultActiveKey="1">
					<a-tab-pane key="1">
						<span slot="tab">按组织架构选择</span>
						<div class="rm-content">
							<a-input-search style="margin-bottom: 8px" placeholder="Search" @change="onSearchChange"/>
							<a-tree v-if="treeData.length"
							        checkable
							        :treeData="treeData"
							        defaultExpandAll
							        :expandedKeys="expandedKeys"
							        :autoExpandParent="autoExpandParent"
							        v-model="checkedKeys"
							        @expand="onExpand"
							>
							</a-tree>
						</div>
					</a-tab-pane>
					<!-- <a-tab-pane key="2" forceRender>
					  <span slot="tab">按角色选择</span>
					  <div class="rm-content">
						<a-tree
						  checkable
						  :autoExpandParent="autoExpandParent"
						  v-model="formData.checkedKeys"
						  :treeData="treeData"
						/>
					  </div>
					</a-tab-pane>-->
				</a-tabs>
				<div class="confrim-footer rm-content">
					<a-button @click="submitClick" type="primary" class="cf-mr10">确定</a-button>
					<a-button @click="closeModel">取消</a-button>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
  export default {
    props: {
      roleData: {
        type: Object,
        default: () => {
        }
      }
    },
    data() {
      return {
        treeData: [],
        autoExpandParent: false,
        checkedKeys: [],
        expandedKeys: [],
        dataList: [],
        searchValue: '',
      };
    },
    mounted() {
      this.findTreeData();
    },
    methods: {
      closeModel() {
        this.$emit("close");
      },
      submitClick() {
        let fromData = [];
        this.checkedKeys.forEach(item => {
          let keyAry = item.split("user-");
          if (keyAry.length == 2) {
            fromData.push(keyAry[1]);
          }
        });
        this.$put(
          "role/memberRoleUpdate?roleId=" + this.roleData.roleId,
          fromData,
          true
        ).then(res => {
          this.$message.success("操作成功");
          this.$emit("close");
        });
      },
      findTreeData() {
        this.$get("dept/findDeptTreeAndUsersList").then(
          res => {
            this.treeData = res.data.data;
            this.treeData.forEach(item => {
              this.createTreeData(item, "deptName", false);
            });
            this.generateList(this.treeData);
            setTimeout(() => {
              this.roleData.userList.forEach(item => {
                let userKey = "user-" + item.userId;
                this.checkedKeys.push(userKey);
              });
            });
          },
          err => {
            console.log("err", err);
          }
        );
      },
      createTreeData(data, key, status) {
        if (key == 'nickName') {
          data.key = 'user-' + data.userId;
        } else {
          data.key = data.parentId + '-' + data.deptId;
        }
        data.title = data[key];
        if (data.children) {
          data.children.forEach(item => {
            this.createTreeData(item, key, status);
          });
        }
        if (data.userList && data.userList.length > 0) {
          data.children = data.userList;
          data.children.forEach(item => {
            this.createTreeData(item, "nickName", true);
          });
        }
      },
      onExpand(expandedKeys) {
        this.expandedKeys = expandedKeys;
        this.autoExpandParent = false;
      },
      onSearchChange(e) {
        let value = e.target.value;
        if (value) {
          const expandedKeys = this.dataList.map(item => {
            if (item.title.indexOf(value) > -1) {
              return this.getParentKey(item.title, this.treeData);
            }
            return null;
          }).filter((item, i, self) => item && self.indexOf(item) === i);
          Object.assign(this, {
            expandedKeys,
            searchValue: value,
            autoExpandParent: true,
          });
        } else {
          const expandedKeys = [];
          Object.assign(this, {
            expandedKeys,
            searchValue: value,
            autoExpandParent: false,
          });
        }
      },
      generateList(data) {
        for (let i = 0; i < data.length; i++) {
          const node = data[i];
          const key = node.key;
          this.dataList.push({key, title: node.title});
          if (node.children) {
            this.generateList(node.children, node.title);
          }
        }
      },
      getParentKey(key, tree) {
        let parentKey;
        for (let i = 0; i < tree.length; i++) {
          const node = tree[i];
          if (node.children) {
            if (node.children.some(item => item.title === key)) {
              parentKey = node.key;
            } else if (this.getParentKey(key, node.children)) {
              parentKey = this.getParentKey(key, node.children);
            }
          }
        }
        return parentKey;
      }
    }
  };
</script>

<style lang="scss">
	.form-model-main {
		.content.role-member-content {
			padding: 0 0;
		}
		.rm-content {
			padding: 0 45px;
		}
		.confrim-footer {
			padding: 45px 45px;
		}
	}

	.rm-tabs {
		.ant-tabs-nav {
			margin: 0 25px;
		}
	}
</style>